"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductsDetailsValues = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const client_constants_1 = require("../../../../../client/client.constants");
const client_utils_1 = require("../../../../../client/client.utils");
const hooks_1 = require("../../../../../client/hooks");
const get_strategy_values_query_1 = require("../../../../../client/values/get-strategy-values.query");
const values_utils_1 = require("../../../../../client/values/values.utils");
const models_1 = require("../../../../../models");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevAttributes = [] } = (_a = previousResult.productTreeNode.labelValidation) !== null && _a !== void 0 ? _a : {};
    const { productTreeNode } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    if (!(productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.labelValidation)) {
        return previousResult;
    }
    const _c = productTreeNode.labelValidation, { edges = [] } = _c, strategyLabels = __rest(_c, ["edges"]);
    if (!edges.length) {
        return {
            productTreeNode: Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode),
        };
    }
    const newAttribute = edges[0].node;
    const changedAttributeIndex = prevAttributes.findIndex(({ node }) => node.label === newAttribute.label);
    const prevAttribute = prevAttributes[changedAttributeIndex];
    if (!prevAttribute) {
        return {
            productTreeNode: Object.assign(Object.assign({}, productTreeNode), { labelValidation: Object.assign(Object.assign({}, strategyLabels), { edges: [...prevAttributes, ...edges] }) }),
        };
    }
    const changedAttribute = {
        node: Object.assign(Object.assign({}, prevAttribute.node), { values: Object.assign(Object.assign({}, newAttribute.values), { edges: [...prevAttribute.node.values.edges, ...newAttribute.values.edges] }) }),
    };
    const newAttributes = (0, ramda_1.update)(changedAttributeIndex, changedAttribute, prevAttributes);
    return {
        productTreeNode: Object.assign(Object.assign({}, productTreeNode), { labelValidation: Object.assign(Object.assign({}, strategyLabels), { edges: newAttributes }) }),
    };
};
const fetchMoreOptions = { updateQuery };
const useProductsDetailsValues = ({ productTreeNodeId, catalogId, attributeName, sortingItem = models_1.SortingItem.SortByTextAsc, options, pageSize = client_constants_1.PAGE_SIZE_LARGE, filter, }) => {
    var _a, _b, _c, _d, _e;
    const sort = values_utils_1.sortingItemToStrategyValuesSortMap[sortingItem];
    const [getStrategyValues, { data, error, networkStatus, variables, fetchMore, refetch, }] = (0, react_2.useLazyQuery)(get_strategy_values_query_1.GET_STRATEGY_VALUES, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: (_a = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _a !== void 0 ? _a : 'network-only',
    });
    const defaultVariables = (0, react_1.useMemo)(() => ({
        catalogId,
        sort,
        productTreeNodeId: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : '',
        label: attributeName,
        filter,
        first: pageSize,
        before: null,
        after: null,
        last: null,
    }), [catalogId, sort, productTreeNodeId, attributeName, filter, pageSize]);
    const loadProductDetailsValues = (0, react_1.useCallback)(() => getStrategyValues({ variables: defaultVariables }), [getStrategyValues, defaultVariables]);
    const { edges = [], pageInfo } = (_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _b === void 0 ? void 0 : _b.labelValidation) === null || _c === void 0 ? void 0 : _c.edges[0]) === null || _d === void 0 ? void 0 : _d.node.values) !== null && _e !== void 0 ? _e : {};
    const attributeValues = (0, react_1.useMemo)(() => { var _a; return (_a = edges === null || edges === void 0 ? void 0 : edges.map(({ node }) => node.value)) !== null && _a !== void 0 ? _a : []; }, [edges]);
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        networkStatus,
        pageSize: client_constants_1.PAGE_SIZE_LARGE,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    const onRefetch = (0, react_1.useCallback)((newVariables) => refetch(Object.assign(Object.assign(Object.assign({}, variables), newVariables), { first: pageSize, before: null, after: null, last: null })), [pageSize, variables, refetch]);
    const onSearch = (0, react_1.useCallback)((searchString) => onRefetch({
        filter: {
            some: {
                value: {
                    contains: searchString.trim(),
                    mode: graphql_1.StringFilterMode.Insensitive,
                },
            },
        },
    }), [onRefetch]);
    return {
        data: attributeValues,
        loadProductDetailsValues,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        error,
        pagination,
        onSearch,
    };
};
exports.useProductsDetailsValues = useProductsDetailsValues;
